/* hesatek-favorites-swedish-i18n-v1 */
(function () {
  'use strict';

  var STORAGE_KEY = 'hesatek:favorites:v1';
  var STORAGE_VERSION = 1;
  var MAX_ITEMS = 100;
  var TOAST_DURATION = 3200;
  var productCache = {};
  var productMetaCache = {};
  var toastTimer = null;
  var renderSequence = 0;
  var cardPositionFrame = null;
  var cardPositionObserver = null;
  var HTK_LANG = (document.documentElement.lang || '').toLowerCase();
  var IS_EN = HTK_LANG.indexOf('en') === 0;
  var IS_SV = HTK_LANG.indexOf('sv') === 0;
  function htkText(fi, en, sv) { return IS_EN ? en : (IS_SV ? (sv || en) : fi); }

  function emptyState() {
    return {
      version: STORAGE_VERSION,
      updatedAt: new Date().toISOString(),
      items: []
    };
  }

  function normalizeId(value) {
    if (value === null || value === undefined) return '';
    return String(value).replace(/^gid:\/\/shopify\/ProductVariant\//, '');
  }

  function normalizeState(value) {
    if (!value || !Array.isArray(value.items)) return emptyState();

    var seen = {};
    var items = value.items.filter(function (item) {
      if (!item || !normalizeId(item.variantId) || !item.handle) return false;
      var key = normalizeId(item.variantId);
      if (seen[key]) return false;
      seen[key] = true;
      item.variantId = key;
      return true;
    }).slice(0, MAX_ITEMS);

    return {
      version: STORAGE_VERSION,
      updatedAt: value.updatedAt || new Date().toISOString(),
      items: items
    };
  }

  function readState() {
    try {
      return normalizeState(JSON.parse(window.localStorage.getItem(STORAGE_KEY)));
    } catch (error) {
      return emptyState();
    }
  }

  function writeState(state) {
    state.version = STORAGE_VERSION;
    state.updatedAt = new Date().toISOString();

    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      showToast(htkText('Suosikkeja ei voitu tallentaa tällä selaimella.', 'Favourites could not be saved in this browser.', 'Favoriterna kunde inte sparas i den här webbläsaren.'));
      return false;
    }

    updateInterface(state);
    document.dispatchEvent(new CustomEvent('hesatek:favorites:changed', {
      detail: { count: state.items.length }
    }));
    return true;
  }

  function itemIndex(state, variantId) {
    var normalized = normalizeId(variantId);
    return state.items.findIndex(function (item) {
      return normalizeId(item.variantId) === normalized;
    });
  }

  function cleanVariantTitle(value) {
    if (!value || value === 'Default Title') return '';
    return value;
  }

  function normalizeImage(value) {
    if (!value) return '';
    if (value.indexOf('//') === 0) return 'https:' + value;
    return value;
  }

  function parseBoolean(value) {
    return value === true || value === 'true' || value === '1';
  }

  function itemFromButton(button) {
    return {
      productId: String(button.dataset.productId || ''),
      variantId: normalizeId(button.dataset.variantId),
      handle: button.dataset.handle || '',
      favoriteContext: button.dataset.favoriteContext || 'unknown',
      productTitle: button.dataset.productTitle || '',
      variantTitle: cleanVariantTitle(button.dataset.variantTitle),
      url: button.dataset.productUrl || '',
      image: normalizeImage(button.dataset.image || ''),
      savedPrice: Number(button.dataset.price || 0),
      currency: button.dataset.currency || 'EUR',
      available: parseBoolean(button.dataset.available),
      savedAt: new Date().toISOString()
    };
  }

  function updateButton(button, active) {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');

    var productTitle = button.dataset.productTitle || 'tuote';
    var label = button.querySelector('[data-hesatek-favorite-label]');
    var text = active ? htkText('Poista suosikeista', 'Remove from favourites', 'Ta bort från favoriter') : htkText('Tallenna suosikiksi', 'Save to favourites', 'Spara som favorit');

    button.setAttribute('aria-label', text + ': ' + productTitle);
    button.setAttribute('title', text);
    if (label) label.textContent = text;
  }

  function updateButtons(state) {
    document.querySelectorAll('[data-hesatek-favorite-button]').forEach(function (button) {
      updateButton(button, itemIndex(state, button.dataset.variantId) !== -1);
    });
  }

  function updateHeaderCount(state) {
    document.querySelectorAll('[data-hesatek-favorites-count]').forEach(function (count) {
      count.textContent = String(state.items.length);
      count.hidden = state.items.length === 0;
    });

    document.querySelectorAll('[data-hesatek-favorites-link]').forEach(function (link) {
      var suffix = state.items.length === 1 ? htkText('1 tuote', '1 product', '1 produkt') : state.items.length + htkText(' tuotetta', ' products', ' produkter');
      link.setAttribute('aria-label', htkText('Suosikit, ', 'Favourites, ', 'Favoriter, ') + suffix);
    });
  }

  function updateInterface(state) {
    updateButtons(state);
    updateHeaderCount(state);
  }

  function ensureToast() {
    var toast = document.querySelector('[data-hesatek-favorites-toast]');
    if (toast) return toast;

    toast = document.createElement('div');
    toast.className = 'hesatek-favorites-toast';
    toast.setAttribute('data-hesatek-favorites-toast', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-atomic', 'true');
    document.body.appendChild(toast);
    return toast;
  }

  function showToast(message) {
    var toast = ensureToast();
    window.clearTimeout(toastTimer);
    toast.textContent = message;
    toast.classList.add('is-visible');

    toastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, TOAST_DURATION);
  }

  function analyticsItem(item, listName) {
    return {
      item_id: normalizeId(item.productId) || normalizeId(item.variantId),
      item_name: item.productTitle || '',
      item_variant: cleanVariantTitle(item.variantTitle),
      item_list_id: 'favorites',
      item_list_name: listName || 'Suosikit',
      variant_id: normalizeId(item.variantId),
      product_handle: item.handle || '',
      wishlist_source: item.favoriteContext || 'unknown',
      price: Number(item.savedPrice || 0) / 100,
      quantity: 1
    };
  }

  function track(eventName, item, extra) {
    window.dataLayer = window.dataLayer || [];
    var payload = {
      event: eventName,
      hesatek_favorites: Object.assign({
        storage: 'localStorage',
        product_id: item ? normalizeId(item.productId) : '',
        variant_id: item ? normalizeId(item.variantId) : '',
        product_handle: item ? item.handle : '',
        source: item ? (item.favoriteContext || 'unknown') : ''
      }, extra || {})
    };

    if (item) {
      payload.ecommerce = {
        currency: item.currency || 'EUR',
        value: Number(item.savedPrice || 0) / 100,
        items: [analyticsItem(item)]
      };
    }

    window.dataLayer.push(payload);
  }

  function toggleFavorite(button) {
    var state = readState();
    var item = itemFromButton(button);
    var index = itemIndex(state, item.variantId);

    if (!item.variantId || !item.handle) {
      showToast(htkText('Tuotevaihtoehtoa ei voitu tallentaa.', 'The product option could not be saved.', 'Produktalternativet kunde inte sparas.'));
      return;
    }

    if (index !== -1) {
      var removed = state.items[index];
      state.items.splice(index, 1);
      if (writeState(state)) {
        showToast(htkText('Poistettu suosikeista', 'Removed from favourites', 'Borttagen från favoriter'));
        track('remove_from_wishlist', removed);
      }
      return;
    }

    if (state.items.length >= MAX_ITEMS) {
      showToast(htkText('Suosikeissa voi olla enintään ' + MAX_ITEMS + ' tuotetta.', 'You can save up to ' + MAX_ITEMS + ' products as favourites.', 'Du kan spara upp till ' + MAX_ITEMS + ' produkter som favoriter.'));
      return;
    }

    state.items.unshift(item);
    if (writeState(state)) {
      showToast(htkText('Tallennettu suosikkeihin', 'Saved to favourites', 'Sparad som favorit'));
      track('added-to-wishlist', item);
    }
  }

  function updateButtonFromVariant(button, variant) {
    if (!button || !variant) return;

    button.dataset.variantId = normalizeId(variant.id || variant.variantId);
    button.dataset.variantTitle = cleanVariantTitle(variant.title || variant.variantTitle || '');
    button.dataset.price = String(variant.price || 0);
    button.dataset.available = variant.available ? 'true' : 'false';

    var image = variant.featured_image || variant.featuredImage;
    if (image && typeof image === 'object') image = image.src || image.url;
    if (image) button.dataset.image = normalizeImage(image);

    if (variant.url) button.dataset.productUrl = variant.url;
    updateButton(button, itemIndex(readState(), button.dataset.variantId) !== -1);
  }

  function positionCardFavoriteButtons() {
    cardPositionFrame = null;

    document.querySelectorAll('.hesatek-favorite-button--card').forEach(function (button) {
      var card = button.closest('.product-item');
      var media = button.closest('.hesatek-product-item-media');
      if (!card || !media) return;

      var cardRect = card.getBoundingClientRect();
      var mediaRect = media.getBoundingClientRect();
      if (!cardRect.width || !mediaRect.width) return;

      var gap = window.matchMedia('(max-width: 479px)').matches ? 8 : 10;
      var isRecentlyViewed = Boolean(
        button.closest('[data-section-type="recently-viewed-products"]')
      );
      var desiredTop = (isRecentlyViewed ? mediaRect.top : cardRect.top) + gap;
      var labelList = card.querySelector('.product-item__label-list');

      if (labelList) {
        var labelRect = labelList.getBoundingClientRect();
        if (labelRect.height > 0) {
          desiredTop = Math.max(desiredTop, labelRect.bottom + gap);
        }
      }

      var right = isRecentlyViewed
        ? gap
        : mediaRect.right - (cardRect.right - gap);
      var top = Math.max(gap, desiredTop - mediaRect.top);
      var maxTop = Math.max(gap, mediaRect.height - button.offsetHeight - gap);
      top = Math.min(top, maxTop);
      button.style.setProperty('--hesatek-card-favorite-right', Math.round(right) + 'px');
      button.style.setProperty('--hesatek-card-favorite-top', Math.round(top) + 'px');
    });
  }

  function scheduleCardFavoritePositions() {
    if (cardPositionFrame !== null) {
      window.cancelAnimationFrame(cardPositionFrame);
    }
    cardPositionFrame = window.requestAnimationFrame(positionCardFavoriteButtons);
  }

  function observeCardFavoritePositions() {
    if (!window.MutationObserver || !document.body || cardPositionObserver) return;

    cardPositionObserver = new MutationObserver(function (mutations) {
      var hasNewCardButton = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return false;
          return node.matches('.hesatek-favorite-button--card') ||
            Boolean(node.querySelector('.hesatek-favorite-button--card'));
        });
      });

      if (hasNewCardButton) scheduleCardFavoritePositions();
    });

    cardPositionObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('load', function (event) {
      if (
        event.target &&
        event.target.tagName === 'IMG' &&
        event.target.closest('.product-item')
      ) {
        scheduleCardFavoritePositions();
      }
    }, true);
  }

  function setCardPriceText(element, value) {
    if (!element || !value) return;
    Array.prototype.slice.call(element.childNodes).forEach(function (node) {
      if (node.nodeType === 3) element.removeChild(node);
    });
    element.appendChild(document.createTextNode(value));
  }

  function updateCardPriceFromSwatch(card, input) {
    var priceList = card.querySelector('.product-item__price-list');
    var currentPrice = priceList && priceList.querySelector('.price:not(.price--compare)');
    var variantPrice = Number(input.dataset.hesatekVariantPrice || 0);
    var compareAtPrice = Number(input.dataset.hesatekVariantCompareAtPrice || 0);
    var formattedPrice = formatMoney(variantPrice);
    var onSale = compareAtPrice > variantPrice;

    if (currentPrice && formattedPrice) {
      currentPrice.classList.toggle('price--highlight', onSale);
      setCardPriceText(currentPrice, formattedPrice);

      var comparePrice = priceList.querySelector('.price--compare');
      if (onSale && !comparePrice) {
        comparePrice = document.createElement('span');
        comparePrice.className = 'price price--compare';

        var regularPriceLabel = document.createElement('span');
        regularPriceLabel.className = 'visually-hidden';
        regularPriceLabel.textContent = input.dataset.hesatekRegularPriceLabel || 'Regular price';
        comparePrice.appendChild(regularPriceLabel);
        currentPrice.insertAdjacentElement('afterend', comparePrice);
      }

      if (comparePrice) {
        comparePrice.hidden = !onSale;
        if (onSale) {
          setCardPriceText(
            comparePrice,
            formatMoney(compareAtPrice)
          );
        }
      }
    }

    var installedPrice = card.querySelector('[data-hesatek-card-installed-price]');
    if (installedPrice) {
      installedPrice.textContent = formatMoney(variantPrice + 74900);
    }
  }

  function updateButtonFromSwatch(input) {
    var card = input.closest('.product-item');
    if (!card || !input.dataset.hesatekVariantId) return;

    updateCardPriceFromSwatch(card, input);

    var button = card.querySelector('[data-hesatek-favorite-button]');
    if (!button) return;

    updateButtonFromVariant(button, {
      id: input.dataset.hesatekVariantId,
      title: input.dataset.hesatekVariantTitle,
      price: Number(input.dataset.hesatekVariantPrice || 0),
      available: parseBoolean(input.dataset.hesatekVariantAvailable),
      featured_image: input.dataset.hesatekVariantImage,
      url: input.dataset.variantUrl
    });
  }

  function formatMoney(cents, currency) {
    return window.HesatekPrice.format(cents);
  }

  function rootUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return root || '/';
  }

  function productJsonUrl(handle) {
    return rootUrl() + 'products/' + encodeURIComponent(handle) + '.js';
  }

  function loadProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = window.fetch(productJsonUrl(handle), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Product request failed');
        return response.json();
      }).catch(function () {
        return null;
      });
    }
    return productCache[handle];
  }

  function loadProductMeta(handle) {
    if (!productMetaCache[handle]) {
      var url = productJsonUrl(handle).replace(/\.js$/, '');
      url += '?section_id=hesatek-favorite-product-data';

      productMetaCache[handle] = window.fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      }).then(function (response) {
        if (!response.ok) return null;
        return response.text();
      }).then(function (html) {
        if (!html) return null;
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        var data = documentFragment.querySelector('[data-hesatek-favorite-product-meta]');
        if (!data) return null;

        try {
          return JSON.parse(data.textContent);
        } catch (error) {
          return null;
        }
      }).catch(function () {
        return null;
      });
    }
    return productMetaCache[handle];
  }

  function loadFavoriteProduct(handle) {
    return Promise.all([loadProduct(handle), loadProductMeta(handle)]).then(function (values) {
      var product = values[0];
      if (product) product.hesatekFavoriteMeta = values[1];
      return product;
    });
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  function productUrl(item, variantId) {
    var fallback = rootUrl() + 'products/' + encodeURIComponent(item.handle);
    try {
      var url = new URL(item.url || fallback, window.location.origin);
      url.searchParams.set('variant', normalizeId(variantId));
      return url.pathname + url.search;
    } catch (error) {
      return fallback + '?variant=' + encodeURIComponent(normalizeId(variantId));
    }
  }

  function currentVariant(item, product) {
    if (!product || !Array.isArray(product.variants)) return null;
    var savedId = normalizeId(item.variantId);
    return product.variants.find(function (variant) {
      return normalizeId(variant.id) === savedId;
    }) || product.variants.find(function (variant) {
      return variant.available;
    }) || product.variants[0] || null;
  }

  function priceChangeNode(item, variant) {
    var saved = Number(item.savedPrice || 0);
    var current = Number(variant && variant.price || saved);
    if (!saved || current === saved) return null;

    var lower = current < saved;
    var difference = Math.abs(current - saved);
    var node = element(
      'p',
      'hesatek-favorites-card__price-change ' + (lower ? 'is-lower' : 'is-higher'),
      (lower ? htkText('Hinta laskenut ', 'Price decreased by ', 'Priset sänktes med ') : htkText('Hinta noussut ', 'Price increased by ', 'Priset höjdes med ')) + formatMoney(difference, item.currency)
    );
    return node;
  }

  function variantSelector(item, product, variant) {
    if (!product || !Array.isArray(product.variants) || product.variants.length <= 1) {
      if (variant && cleanVariantTitle(variant.title)) {
        return element('p', 'hesatek-favorites-card__variant-static', cleanVariantTitle(variant.title));
      }
      return null;
    }

    var wrapper = element('div', 'hesatek-favorites-card__variant');
    var id = 'favorite-variant-' + normalizeId(item.variantId);
    var label = element('label', 'hesatek-favorites-card__label', htkText('Vaihtoehto', 'Option', 'Alternativ'));
    label.setAttribute('for', id);

    var select = element('select', 'hesatek-favorites-card__select');
    select.id = id;
    select.setAttribute('data-hesatek-favorite-variant-select', '');
    select.dataset.savedVariantId = normalizeId(item.variantId);

    product.variants.forEach(function (option) {
      var optionNode = element(
        'option',
        '',
        cleanVariantTitle(option.title) + ' – ' + formatMoney(option.price, item.currency)
      );
      optionNode.value = normalizeId(option.id);
      optionNode.selected = normalizeId(option.id) === normalizeId(variant.id);
      optionNode.disabled = !option.available;
      if (!option.available) optionNode.textContent += htkText(' (loppu)', ' (sold out)', ' (slutsåld)');
      select.appendChild(optionNode);
    });

    wrapper.appendChild(label);
    wrapper.appendChild(select);
    return wrapper;
  }

  function comparisonSpecs(product) {
    var meta = product && product.hesatekFavoriteMeta;
    if (!meta || !meta.isAirSourceHeatPump || !Array.isArray(meta.specs)) return null;

    var specs = meta.specs.filter(function (spec) {
      if (!spec || !spec.label || spec.value === null || spec.value === undefined) return false;
      if (meta.isCoolingOnly && spec.mode === 'heating') return false;

      var normalizedValue = String(spec.value).trim().toLocaleLowerCase('fi-FI');
      return normalizedValue !== '' &&
        normalizedValue !== 'vain viilennykseen' &&
        normalizedValue !== '-' &&
        normalizedValue !== '—';
    });
    if (!specs.length) return null;

    var wrapper = element('section', 'hesatek-favorites-card__specs');
    wrapper.setAttribute('aria-label', htkText('Ilmalämpöpumpun vertailutiedot', 'Air source heat pump comparison details', 'Jämförelseuppgifter för luftvärmepump'));
    var heading = element('h3', 'hesatek-favorites-card__specs-title', htkText('Vertailutiedot', 'Comparison details', 'Jämförelseuppgifter'));
    var list = element('dl', 'hesatek-favorites-card__specs-list');

    specs.forEach(function (spec) {
      var row = element('div', 'hesatek-favorites-card__spec');
      row.appendChild(element('dt', '', spec.label));
      row.appendChild(element('dd', '', String(spec.value)));
      list.appendChild(row);
    });

    wrapper.appendChild(heading);
    wrapper.appendChild(list);
    return wrapper;
  }

  function renderFavoriteCard(item, product) {
    var variant = currentVariant(item, product);
    var article = element('article', 'hesatek-favorites-card');
    article.dataset.variantId = normalizeId(item.variantId);
    article.dataset.handle = item.handle;

    var imageLink = element('a', 'hesatek-favorites-card__image-link');
    imageLink.href = productUrl(item, variant ? variant.id : item.variantId);

    var image = element('img', 'hesatek-favorites-card__image');
    var variantImage = variant && variant.featured_image;
    if (variantImage && typeof variantImage === 'object') variantImage = variantImage.src;
    image.src = normalizeImage(variantImage || (product && product.featured_image) || item.image);
    image.alt = item.productTitle || (product && product.title) || '';
    image.loading = 'lazy';
    image.width = 600;
    image.height = 600;
    imageLink.appendChild(image);

    var remove = element('button', 'hesatek-favorites-card__remove');
    remove.type = 'button';
    remove.setAttribute('data-hesatek-favorite-remove', '');
    remove.dataset.variantId = normalizeId(item.variantId);
    remove.setAttribute('aria-label', htkText('Poista suosikeista: ', 'Remove from favourites: ', 'Ta bort från favoriter: ') + (item.productTitle || 'tuote'));
    remove.innerHTML = [
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">',
      '<path fill="currentColor"',
      ' d="M9 3h6l1 2h4v2H4V5h4l1-2Zm-2 6h10l-.8 12H7.8L7 9Zm3 2v8h2v-8h-2Zm4 0v8h2v-8h-2Z"/>',
      '</svg>'
    ].join('');

    var content = element('div', 'hesatek-favorites-card__content');
    var title = element('h2', 'hesatek-favorites-card__title');
    var titleLink = element('a', '', item.productTitle || (product && product.title) || htkText('Tuote', 'Product', 'Produkt'));
    titleLink.href = imageLink.href;
    title.appendChild(titleLink);

    var price = element(
      'p',
      'hesatek-favorites-card__price',
      formatMoney(variant ? variant.price : item.savedPrice, item.currency)
    );

    var priceChange = priceChangeNode(item, variant);
    var selector = variantSelector(item, product, variant);
    var specs = comparisonSpecs(product);
    var availability = element(
      'p',
      'hesatek-favorites-card__availability ' + (variant && variant.available ? 'is-available' : 'is-unavailable'),
      variant && variant.available ? htkText('Saatavilla', 'Available', 'Tillgänglig') : htkText('Ei saatavilla', 'Unavailable', 'Inte tillgänglig')
    );

    if (product && variant && normalizeId(variant.id) !== normalizeId(item.variantId)) {
      var missing = element(
        'p',
        'hesatek-favorites-card__notice',
        htkText('Tallennettu vaihtoehto ei ole enää saatavilla. Valitse uusi vaihtoehto.', 'The saved option is no longer available. Choose another option.', 'Det sparade alternativet är inte längre tillgängligt. Välj ett annat alternativ.')
      );
      content.appendChild(missing);
    }

    var actions = element('div', 'hesatek-favorites-card__actions');
    var add = element('button', 'button button--primary hesatek-favorites-card__add', htkText('Lisää ostoskoriin', 'Add to cart', 'Lägg i varukorgen'));
    add.type = 'button';
    add.setAttribute('data-hesatek-favorite-add-cart', '');
    add.dataset.variantId = variant ? normalizeId(variant.id) : normalizeId(item.variantId);
    add.disabled = !variant || !variant.available;

    actions.appendChild(add);

    content.appendChild(title);
    if (selector) content.appendChild(selector);
    content.appendChild(price);
    if (priceChange) content.appendChild(priceChange);
    if (specs) content.appendChild(specs);
    content.appendChild(availability);
    content.appendChild(actions);

    article.appendChild(imageLink);
    article.appendChild(remove);
    article.appendChild(content);
    return article;
  }

  function sortedFavorites(items, products, sortValue) {
    var rows = items.map(function (item, index) {
      return {
        item: item,
        product: products[index],
        originalIndex: index
      };
    });

    rows.sort(function (a, b) {
      var aVariant = currentVariant(a.item, a.product);
      var bVariant = currentVariant(b.item, b.product);
      var aPrice = Number(aVariant && aVariant.price || a.item.savedPrice || 0);
      var bPrice = Number(bVariant && bVariant.price || b.item.savedPrice || 0);
      var aTime = new Date(a.item.savedAt || 0).getTime();
      var bTime = new Date(b.item.savedAt || 0).getTime();

      if (sortValue === 'oldest') return aTime - bTime;
      if (sortValue === 'price-ascending') return aPrice - bPrice;
      if (sortValue === 'price-descending') return bPrice - aPrice;
      return bTime - aTime;
    });

    return rows;
  }

  function renderFavoritesPage() {
    var page = document.querySelector('[data-hesatek-favorites-page]');
    if (!page) return;

    var sequence = ++renderSequence;
    var state = readState();
    var grid = page.querySelector('[data-hesatek-favorites-grid]');
    var empty = page.querySelector('[data-hesatek-favorites-empty]');
    var loading = page.querySelector('[data-hesatek-favorites-loading]');
    var summary = page.querySelector('[data-hesatek-favorites-summary]');
    var sort = page.querySelector('[data-hesatek-favorites-sort]');

    grid.innerHTML = '';
    summary.textContent = state.items.length === 1
      ? htkText('1 tallennettu tuote', '1 saved product', '1 sparad produkt')
      : state.items.length + htkText(' tallennettua tuotetta', ' saved products', ' sparade produkter');

    if (state.items.length === 0) {
      loading.hidden = true;
      empty.hidden = false;
      grid.hidden = true;
      return;
    }

    loading.hidden = false;
    empty.hidden = true;
    grid.hidden = true;

    Promise.all(state.items.map(function (item) {
      return loadFavoriteProduct(item.handle);
    })).then(function (products) {
      if (sequence !== renderSequence) return;

      sortedFavorites(state.items, products, sort ? sort.value : 'newest').forEach(function (row) {
        grid.appendChild(renderFavoriteCard(row.item, row.product));
      });

      loading.hidden = true;
      grid.hidden = false;
      track('view_favorites', null, { item_count: state.items.length });
    });
  }

  function removeFavorite(variantId) {
    var state = readState();
    var index = itemIndex(state, variantId);
    if (index === -1) return;
    var removed = state.items[index];
    state.items.splice(index, 1);
    if (writeState(state)) {
      showToast(htkText('Poistettu suosikeista', 'Removed from favourites', 'Borttagen från favoriter'));
      track('remove_from_wishlist', removed);
      renderFavoritesPage();
    }
  }

  function changeFavoriteVariant(select) {
    var card = select.closest('.hesatek-favorites-card');
    if (!card) return;

    var state = readState();
    var oldId = card.dataset.variantId;
    var index = itemIndex(state, oldId);
    if (index === -1) return;

    var item = state.items[index];
    loadProduct(item.handle).then(function (product) {
      if (!product) return;
      var variant = product.variants.find(function (candidate) {
        return normalizeId(candidate.id) === normalizeId(select.value);
      });
      if (!variant) return;

      state.items.splice(index, 1);
      item.variantId = normalizeId(variant.id);
      item.variantTitle = cleanVariantTitle(variant.title);
      item.url = productUrl(item, variant.id);
      item.savedPrice = Number(variant.price || 0);
      item.available = Boolean(variant.available);
      item.savedAt = new Date().toISOString();
      var variantImage = variant.featured_image;
      if (variantImage && typeof variantImage === 'object') variantImage = variantImage.src;
      item.image = normalizeImage(variantImage || product.featured_image || item.image);
      state.items.unshift(item);

      if (writeState(state)) {
        showToast(htkText('Vaihtoehto päivitetty', 'Option updated', 'Alternativet uppdaterat'));
        track('favorite_variant_changed', item, { previous_variant_id: normalizeId(oldId) });
        renderFavoritesPage();
      }
    });
  }

  function addToCart(button) {
    var variantId = normalizeId(button.dataset.variantId);
    if (!variantId || button.disabled) return;

    var state = readState();
    var item = state.items.find(function (candidate) {
      return normalizeId(candidate.variantId) === variantId;
    }) || { variantId: variantId, currency: 'EUR' };

    var originalText = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = htkText('Lisätään…', 'Adding…', 'Lägger till…');

    window.fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    }).then(function () {
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { quantity: 1 }
      }));
      showToast(htkText('Lisätty ostoskoriin', 'Added to cart', 'Tillagd i varukorgen'));
      track('add_to_cart', item, { source: 'favorites' });
    }).catch(function () {
      showToast(htkText('Tuotetta ei voitu lisätä ostoskoriin.', 'The product could not be added to the cart.', 'Produkten kunde inte läggas i varukorgen.'));
    }).finally(function () {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalText;
    });
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      var favoriteButton = event.target.closest('[data-hesatek-favorite-button]');
      if (favoriteButton) {
        event.preventDefault();
        event.stopPropagation();
        toggleFavorite(favoriteButton);
        return;
      }

      var removeButton = event.target.closest('[data-hesatek-favorite-remove]');
      if (removeButton) {
        event.preventDefault();
        removeFavorite(removeButton.dataset.variantId);
        return;
      }

      var addButton = event.target.closest('[data-hesatek-favorite-add-cart]');
      if (addButton) {
        event.preventDefault();
        addToCart(addButton);
      }
    });

    document.addEventListener('change', function (event) {
      if (event.target.matches('.color-swatch__radio[data-hesatek-variant-id]')) {
        updateButtonFromSwatch(event.target);
      }

      if (event.target.matches('[data-hesatek-favorite-variant-select]')) {
        changeFavoriteVariant(event.target);
      }

      if (event.target.matches('[data-hesatek-favorites-sort]')) {
        renderFavoritesPage();
      }
    });

    document.addEventListener('variant:changed', function (event) {
      if (!event.detail || !event.detail.variant) return;
      document.querySelectorAll(
        '.hesatek-favorite-button--product, .hesatek-favorite-button--gallery'
      ).forEach(function (button) {
        updateButtonFromVariant(button, event.detail.variant);
      });
    });

    window.addEventListener('storage', function (event) {
      if (event.key !== STORAGE_KEY) return;
      updateInterface(readState());
      renderFavoritesPage();
    });

    window.addEventListener('resize', scheduleCardFavoritePositions);
    document.addEventListener('shopify:section:load', scheduleCardFavoritePositions);
  }

  function init() {
    var state = readState();
    updateInterface(state);
    bindEvents();
    renderFavoritesPage();
    observeCardFavoritePositions();
    scheduleCardFavoritePositions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
